export default "__VITE_ASSET__1b256b2c__"